"use client";

import * as stylex from "@stylexjs/stylex";
import { styles } from "./forum.styles";
import { Alert, Button } from "@softmax/design-system";
export function RefreshFeedback({
  refreshing,
  error,
  onRefresh,
}: Readonly<{
  refreshing: boolean | undefined;
  error: string | null | undefined;
  onRefresh(): void;
}>) {
  return (
    <div {...stylex.props(styles.feedback)}>
      {refreshing && <output>Refreshing…</output>}
      {error && (
        <Alert tone="danger" announcement="assertive">
          <div {...stylex.props(styles.alertContent)}>
            <span>{error}</span>
            <Button onClick={onRefresh}>Retry</Button>
          </div>
        </Alert>
      )}
    </div>
  );
}
